"use client";

import React from "react";
import Image from "next/image";
import { Box, Typography } from "@mui/material";
import TJModal from "@/components/shared/TJModal/TJModal";
import ModalHeader from "@/utils/ModalHeader";
import useIconGuide from "./hooks/useIconGuide";
import "./guide.scss";

interface GuideModalProps {
  open: boolean;
  onClose: () => void;
}

const GuideModal: React.FC<GuideModalProps> = ({ open, onClose }) => {
  const { modalTitle, emptyMessage, columns, items } = useIconGuide();

  return (
    <TJModal
      open={open}
      onClose={onClose}
      size="large"
      header={
        <ModalHeader title={modalTitle} onClose={onClose} />
      }
    >
      <Box className="guide-modal-content">
        {items.length === 0 ? (
          <Typography className="guide-modal-empty">
            {emptyMessage}
          </Typography>
        ) : (
          <table className="guide-table">
            <thead>
              <tr>
                <th className="guide-table-header guide-table-header-symbol">
                  {columns.symbol}
                </th>
                <th className="guide-table-header guide-table-header-name">
                  {columns.name}
                </th>
                <th className="guide-table-header">
                  {columns.description}
                </th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, index) => (
                <tr
                  key={item.id}
                  className={index % 2 === 1 ? "guide-table-row-alt" : "guide-table-row"}
                >
                  <td className="guide-table-cell">
                    <Image
                      src={item.icon}
                      alt={item.name}
                      width={20}
                      height={20}
                    />
                  </td>
                  <td className="guide-table-cell">
                    {item.name}
                  </td>
                  <td className="guide-table-cell">
                    {item.description}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </Box>
    </TJModal>
  );
};

export default GuideModal;
